// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1i2RH","savePackageButton":"ClientWallet_savePackageButton__doAeB"};